// extracted by mini-css-extract-plugin
module.exports = {"placeholder-element":"style_placeholder-element__3IzUn","animated-background":"style_animated-background__3CVXR","placeHolderShimmer":"style_placeHolderShimmer__2j6kl"};